import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';

/**
 * Versioned GStatic CDN path for Draco WASM decoders.
 * Pinned to 1.5.7 for reproducibility, compatible with Three.js 0.182.
 */
export const DRACO_DECODER_PATH = 'https://www.gstatic.com/draco/versioned/decoders/1.5.7/';

let _dracoLoader: DRACOLoader | null = null;

/**
 * Returns a configured DRACOLoader singleton (WASM, GStatic CDN 1.5.7).
 * The WASM module is loaded once and reused across all viewer instances.
 * `preload()` is called on creation to start WASM download immediately.
 */
export function getDracoLoader(): DRACOLoader {
  if (!_dracoLoader) {
    _dracoLoader = new DRACOLoader();
    _dracoLoader.setDecoderPath(DRACO_DECODER_PATH);
    _dracoLoader.setDecoderConfig({ type: 'wasm' });
    _dracoLoader.preload();
  }
  return _dracoLoader;
}

/**
 * Disposes the singleton DRACOLoader instance.
 * Use for test isolation and HMR cleanup.
 */
export function disposeDracoLoader(): void {
  if (_dracoLoader) {
    _dracoLoader.dispose();
    _dracoLoader = null;
  }
}
